
import { Component, Vue } from "vue-property-decorator";
import Nav from "@/components/Nav.vue";
import Service from "@/components/Service.vue";
import Footerr from "@/components/Footerr.vue";

export default Vue.extend({
  name: "services",
  components: {
    Service,
    Footerr,
    Nav,
  },
  //  data: () => ({
  //
  //  }),
  //  computed: {
  //
  //  },
  //  methods: {
  //
  //  },
});
